module.exports = __webpack_public_path__ + "static/media/myProfile.779fdd0b.jpg";